import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const SplitIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox={`0 0 14 14`} fill="none">
      <path d="M4.875 2.7085L8.66667 2.7085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M4.60409 2.84391C4.60409 3.81616 3.81592 4.60433 2.84367 4.60433C1.87142 4.60433 1.08325 3.81616 1.08325 2.84391C1.08325 1.87166 1.87142 1.0835 2.84367 1.0835C3.81592 1.0835 4.60409 1.87166 4.60409 2.84391Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9167 2.7085C11.9167 3.60596 11.1892 4.3335 10.2917 4.3335C9.39429 4.3335 8.66675 3.60596 8.66675 2.7085C8.66675 1.81103 9.39429 1.0835 10.2917 1.0835C11.1892 1.0835 11.9167 1.81103 11.9167 2.7085Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9167 10.2915C11.9167 11.189 11.1892 11.9165 10.2917 11.9165C9.39429 11.9165 8.66675 11.189 8.66675 10.2915C8.66675 9.39404 9.39429 8.6665 10.2917 8.6665C11.1892 8.6665 11.9167 9.39404 11.9167 10.2915Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 2.77881C5.82292 3.02256 6.52709 3.88922 6.52167 4.91297L6.51625 6.77089C6.51083 8.19006 7.42084 9.39797 8.68834 9.84214"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
